export default {
    nav: {
        main: {
            timeRegistration: 'Time registration',
            roadmap: 'Roadmap',
            operations: 'Operations',
            planning: 'Planning',
            crm: 'CRM',
            infra: 'Infra',
            assets: 'Master data',
            iso: 'ISO',
            docs: 'Docs',
        },
        assets: {
            users: 'Users',
            globalValues: 'Settings',
            globalFiles: 'Special files',
            emailTemplates: 'Email templates',
        },
        audit: {
            accessLog: 'Access log',
        },
        account: {
            account: 'Account',
            changelog: 'Changelog'
        },
        crm: {
            entities: 'Entities',
            companies: 'Companies',
            contacts: 'Contacts',
            teams: 'Teams',
            contracts: 'Contracts'
        },
        operations: {
            tickets: 'Tickets',
            tags: 'Tags',
            milestones: 'Milestones',
            milestoneStatuses: 'Milestone statuses',
            project: 'Projects',
            userSchedule: 'User schedule'
        },
        planning: {
            projectOverview: 'Project Overview',
            developerOverview: 'Developer Overview',
            sprintPlanning: 'Sprint Planning',
            capacityPlanner: 'Capacity Planner',
        },
        timeRegistration: {
            myTime: 'My Time',
            overview: 'Overview'
        },
        infra: {
            server: 'Servers'
        },
        modules: {
            overview: 'Modules',
            whale: {
                overview: 'Whale'
            }
        },
        iso: {
            checks: 'Checks',
            documents: {
                title: 'Documents',
                header: 'Document repository',
                documents: 'Documents',
                chapters: 'Chapters'
            }
        }
    },
    ticket: {
        overview: {
            title: 'Tickets',
        },
        timePerUser: {
            title: 'Time per user',
        },
        aiSpend: {
            heading: 'AI spend',
            title: 'AI spend per request (Synapse)',
            loggedAt: { label: 'Logged at' },
            model: { label: 'Model' },
            callType: { label: 'Call type' },
            tokens: { label: 'Tokens' },
            duration: { label: 'Duration' },
            spend: { label: 'Spend' },
            refreshDetail: 'Refresh detail',
            perKey: {
                title: 'AI spend per key',
                key: 'Key',
                requests: 'Requests',
                tokens: 'Tokens',
                duration: 'Active time',
                spend: 'Spend',
                lastRequest: 'Last request',
                empty: 'No AI sessions synced for this ticket yet.',
            },
        },
        field: {
            id: {
                label: 'ID'
            },
            number: {
                label: 'Ticket'
            },
            title: {
                label: 'Title'
            },
            assignedTo: {
                label: 'Assigned to'
            },
            timeSpent: {
                label: 'Time spent'
            },
            aiSpend: {
                label: 'AI spend'
            },
            person: {
                label: 'Person'
            },
            progress: {
                label: 'Progress',
                empty: 'Ticket is not EBSed!',
                spentLabel: 'Spent',
                plannedLabel: 'Planned',
                percentageLabel: 'Progress',
                overLabel: 'over estimate',
            },
        }
    },
    tag: {
        field: {
            id: {
                label: 'ID'
            },
            name: {
                label: 'Name'
            }
        },
        create: {
            title: 'Create new tag'
        },
        edit: {
            title: 'Edit tag'
        },
        overview: {
            addButton: 'Add tag'
        }
    },
    entity: {
         overview: {
            title: 'Entities',
            addButton: 'Add entity',
        },
        create: {
            title: 'Create entity',
        },
        edit: {
            title: 'Edit entity',
        },
        field: {
             name: {
                 label: 'Name'
             }
        }
    },
    user: {
        overview: {
            title: 'Users',
            addButton: 'Add user',
        },
        create: {
            title: 'Create user',
        },
        edit: {
            title: 'Edit user',
        },
        field: {
            fullName: { label: 'Name' },
            firstName: { label: 'First name' },
            lastName: { label: 'Last name' },
            email: { label: 'Email' },
            password: { label: 'Password' },
            dateJoined: { label: 'Added At' },
            abbreviation: { label: 'Abbreviation' },
            team: { label: 'Team' },
            extraTimeLastMonth: { label: 'Extra time last month' },
            extraTimeThisMonth: { label: 'Extra time this month' },
            missingTimeLastMonth: { label: 'Missing time last month' },
            missingTimeThisMonth: { label: 'Missing time this month' },
            groups: {
                label: 'Groups',
                value: {
                    operation_manager: 'Operation manager',
                    team_lead: 'Team lead',
                    employee: 'Employee',
                    superuser: 'Superuser',
                    admin: 'Admin',
                    manager: 'Manager',
                    experimental: 'Experimental',
                    iso: 'ISO',
                    sales: 'Sales',
                    planner: 'Planner',
                    n8n_integration: 'n8n Integration'
                },
                empty: 'No groups assigned',
            },
            language: {
                label: 'Language'
            },
            isActive: {
                label: 'Users',
                options: {
                    all: 'All',
                    yes: 'Active',
                    no: 'Not active',
                }
            },
            mfa: {
                label: 'MFA methods',
            },
            external: { label: 'External' },
            exactId: { label: 'Exact ID' },
            autoClearTimeRegistration: { label: 'Automatically Clear Time Registration' },
            separateProjectTicketSelects: { label: 'Separate ticket dropdown from projects dropdown' },
            timeSuggestionInstruction: {
                label: 'AI Time Suggestion Instructions',
                placeholder: 'Enter custom instructions for AI time suggestions (e.g., "Focus on project X this week", "Prefer longer detailed descriptions", etc.)'
            },
        },
        login: {
            title: 'Login',
            forgotPasswordLink: 'Forgot password?',
            errors: {
                invalidCredentials: 'Username or password do not match',
                unknown: 'Unknown error, status code: {{status}}',
            },
            loginButton: 'Log In',
        },
        passwordForgot: {
            title: 'Forgot password',
            requestButton: 'Send e-mail',
            requestedEmailText:
                'An email with a reset code has been sent to this email address.',
            loggedInError: 'You are logged in. Password forgot only works when you are not logged in.',
        },
        resetPassword: {
            title: 'Reset password',
            resetButton: 'Reset',
            saveSuccess: 'Password is successfully reset.',
            loggedInError: 'You are logged in. Password reset only works when you are not logged in.',
        },
        changePassword: {
            title: 'Change password',
            field: {
                passwordOld: {
                    label: 'Current password',
                },
                passwordNew: {
                    label: 'New password',
                },
            },
            saveButton: 'Save',
        },
        account: {
            title: 'Account Details',
            logoutButton: 'Log out',
            info: {
                title: 'Account info',
            },
            password: {
                title: 'Change password',
            },
            logout: {
                title: 'Log out',
                confirm: 'Are you sure you want to logout?'
            },
        },
        multiFactorAuth: {
            code: {
                app: 'Verification code',
                email: 'Login code',
                newCode: 'Request new code',
            },
            expiring: 'Your authentication is still valid for {{ minutes }} minutes',
            explanation: {
                app: 'Enter the code that your authenticator app generated.',
                email: 'Your login code has been sent by email.',
            },
            explanationFailed: 'We tried to send a login code to the registered email address, but failed.',
            timeout: 'You tried too many times. You can try again in a few minutes.',
            invalid: {
                app: 'The verification code is incorrect or has expired. Please try again.',
                email: 'The login code is incorrect or has expired. Please try again or request a new code.',
            },
            resend: 'Resend',
            title: 'Confirm',
        },
    },
    myFilter: {
        custom: 'Custom',
        action: {
            unsetDefault: 'Unset default',
            setDefault: 'Set default',
            setCurrent: 'Save current filters',
            delete: 'Delete',
        },
    },
    globalValue: {
        edit: {
            title: 'Edit {{key}}',
        },
        overview: {
            title: 'Settings',
        },
        field: {
            key: {
                label: 'Setting name',
            },
            value: {
                label: 'Value',
            },
            writable: {
                label: 'Writable?',
            },
            readable: {
                label: 'Readable?',
            },
        },
    },
    globalFile: {
        edit: {
            title: 'Edit special file',
        },
        overview: {
            title: 'Special files',
        },
        field: {
            key: {
                label: 'Name for file',
            },
            value: {
                label: 'File',
            },
            writable: {
                label: 'Writable?',
            },
            readable: {
                label: 'Readable?',
            },
        },
    },
    accessLogEntry: {
        overview: {
            title: 'Audit log',
        },
        field: {
            originalUser: {
                label: 'Original user',
            },
            masqueradingAsUser: {
                label: 'Masquerading as user',
            },
            ipAddress: {
                label: 'IP address',
            },
            method: {
                label: 'HTTP method',
            },
            endpoint: {
                label: 'Endpoint',
            },
            statusCode: {
                label: 'Status code',
            },
            additionalInfo: {
                label: 'Extra information',
            },
            requestTime: {
                label: 'Time of access',
            },
        },
    },
    tooltips: {
        masquerade: 'Masquerade',
        edit: 'Edit',
        delete: 'Delete',
        view: 'View',
        restore: 'Restore',
        history: 'History',
        copy: 'Copy',
    },
    form: {
        search: 'Search',
        repeat: 'Repeat',
        fileType: {
            pdf: 'PDF',
            image: 'IMG',
            xls: 'XLS',
            any: 'Other',
            none: 'No file uploaded yet',
        },
        saveButton: 'Save',
        saveAndBackButton: 'Save & Back',
        saveAndNewButton: 'Save & New',
        deleteButton: 'Delete',
        multiPick: {
            searchPlaceholder: 'Select…',
            selectedText: '$1 of $2 selected',
            noneSelectedText: 'None selected',
            selectAllButton: 'All',
            selectNoneButton: 'None',
        },
        notifications: {
            saveSuccess: 'Saved successfully',
            deleteSuccess: 'Deleted successfully',
            saveError: 'Error with saving ({{status}})',
            saveValError: 'Not all information is filled in correctly',
            saveAuthError: 'Invalid credentials',
            newAppVersion:
                'New version available, click to reload page as soon as possible',
        },
        draftJs: {
            style: {
                'header-one': { label: 'H1' },
                'header-two': { label: 'H2' },
                'header-three': { label: 'H3' },
                'header-four': { label: 'H4' },
                'header-five': { label: 'H5' },
                'header-six': { label: 'H6' },
                blockquote: { label: 'Blockquote' },
                'unordered-list-item': { label: 'UL' },
                'ordered-list-item': { label: 'OL' },
                'code-block': { label: 'Code block' },
                BOLD: { label: 'Bold' },
                ITALIC: { label: 'Italic' },
                UNDERLINE: { label: 'Underline' },
                CODE: { label: 'Monospace' },
            },
        },
        submitButton: 'Submit',
        cancelButton: 'Cancel',
        unsavedChangesWarning: 'You have unsaved changes. Do you want to discard them?',
        confirmQuestion: 'Are you sure?',
        continueButton: 'Continue',
        discardChangesButton: 'Discard changes',
        addButton: 'Add',
        startDate: 'Start Date',
        endDate: 'End Date',
        downloadButton: 'Download',
        deleteConfirmation: 'Are you sure you want to delete this entity?',
        restoreConfirmation: 'Are you sure you want to restore this entity?',
        smartDateRange: {
            value: {
                today: 'Today',
                yesterday: 'Yesterday',
                past_7_days: 'Past 7 Days',
                past_30_days: 'Past 30 Days',
                custom: 'Custom',
                last_month: 'Last Month',
                last_quarter: 'Last Quarter',
                last_year: 'Last Year',
                this_month: 'This Month',
                this_quarter: 'This Quarter',
                this_year: 'This Year',
                all_time: 'All Time',
            },
            period: {
                last: 'Last',
                this: 'This',
                value: {
                    month: 'Month',
                    quarter: 'Quarter',
                    year: 'Year',
                },
            },
        },
        no: 'No',
        yes: 'Yes',
        either: 'Either',
    },
    crash: {
        heading: 'Application crashed',
        subHeading1: 'We’re very sorry, but the application has crashed.',
        subHeading2: 'Our team has been notified.',
        reload: 'Reload page'
    },
    emailTemplate: {
        overview: {
            title: 'Email templates',
            addButton: 'Add email template',
        },
        create: { title: 'Create mail template' },
        edit: { title: 'Edit mail template' },
        add: { title: 'Add mail template' },
        field: {
            id: { label: 'ID' },
            isDefault: { label: 'Is default' },
            name: { label: 'Name' },
            emailType: { label: 'Email type' },
            subject: { label: 'Subject' },
            textContent: { label: 'Text variant of email', placeholder: 'Some mail clients only support text' },
            senderEmail: { label: 'Sender email' },
        }
    },
    emailTypes: {
        password_reset: 'Password reset',
        user_activation: 'User activation',
    },
    authentication: {
        dates: {
            maxDate: {
                placeholder: 'Max date',
            },
            minDate: {
                placeholder: 'Min date',
            },
            month: {
                0: 'January',
                1: 'February',
                10: 'November',
                11: 'December',
                2: 'March',
                3: 'April',
                4: 'May',
                5: 'June',
                6: 'July',
                7: 'August',
                8: 'September',
                9: 'October',
            },
            weekDayShort: {
                friday: 'Fr',
                monday: 'Mo',
                saturday: 'Sa',
                sunday: 'Su',
                thursday: 'Th',
                tuesday: 'Tu',
                wednesday: 'We',
            }
        },
        field: {
            mfa: {
                label: 'Method',
            },
            code: {
                label: 'Code',
            },
            expiresAt: {
                label: 'Expired',
            },
            ipAddress: {
                label: 'IP address',
            },
            status: {
                label: 'Status',
                value: {
                    expired: 'Expired',
                    verified: 'Verified',
                    waiting: 'Pending',
                }
            },
            userAgent: {
                label: 'User Agent',
            }
        }
    },
    multiFactorAuthentication: {
        setup: {
            title: 'Set up multi-factor authentication',
            step1: {
                title: '1. Download the app',
                description: 'Download an authenticator app, such as Google Authenticator, if you don\'t have one already.',
            },
            step2: {
                title: '2. Scan the QR code',
                description: 'Scan this QR code with your authenticator app.',
            },
            step3: {
                title: '3. Enter the code',
                description: 'Enter the code you see in your authenticator app.',
            },
            subtitle: 'After setup, you can always log in securely using your authenticator app.',
        },
        field: {
            method: {
                label: 'MFA method',
                options: {
                    app: 'Authenticator app',
                    email: 'Email',
                }
            },
            counter: {
                label: 'Uses',
            },
            activated: {
                label: 'Verified',
            },
        }
    },
    daycy: {
        week: {
            label: 'Wk',
            number: '{{week}}',
        },
        weekDay: {
            monday: 'Mo',
            tuesday: 'Tu',
            wednesday: 'We',
            thursday: 'Th',
            friday: 'Fr',
            saturday: 'Sa',
            sunday: 'Su',
        },
        month: {
            january: 'January',
            february: 'February',
            march: 'March',
            april: 'April',
            may: 'May',
            june: 'June',
            july: 'July',
            august: 'August',
            september: 'September',
            october: 'October',
            november: 'November',
            december: 'December',
        },
    },
    pageNotFoundMessage: 'Page not found',
    brandingMessage: 'Powered by Code Yellow',
    milestone: {
        overview: {
            title: 'Milestones',
            addChild: 'Add child',
            new: 'NEW',
            dragInfo: 'After dragging milestones get inserted as a main milestone by default, hold shift to insert them as a sub milestone instead.',
        },
        field: {
            id: { label: 'ID' },
            status: { label: 'Status',
                options: {
                    not_started: 'Not started',
                    wip: 'Work in progress',
                    completed: 'Completed'
                }
            },
            flagged: {
                label: 'Flagged',
                options: {
                    all: 'Both',
                    yes: 'Flagged',
                    no: 'Not flagged',
                }
            },
            onHold: {
                label: 'On hold',
                options: {
                    all: 'Both',
                    yes: 'On hold',
                    no: 'Not on hold',
                }
            },
            dueAt: { label: 'Due at' },
            name: { label: 'Name' },
            notes: { label: 'Notes' },
            ticket: { label: 'Ticket' },
            deliveredBy: { label: 'Delivered by' },
            receivedBy: { label: 'Received by' },
            team: { label: 'Team' },
            project: { label: 'Project' },
            company: { label: 'Company' },
            createdAt: { label: 'Created at' },
            noteThread: { label: 'Note thread' },
            ordering: { label: 'Ordering' },
            parent: { label: 'Parent' }
        },
        create: {
            title: 'Create milestone'
        }
    },
    milestoneStatus: {
        overview: {
            addButton: 'Add milestone status'
        },
        create: {
            title: 'Add milestone status'
        },
        edit: {
            title: 'Edit milestone status'
        },
        field: {
            id: {
                label: 'ID'
            },
            name: {
                label: 'Name'
            },
            color: {
                label: 'Color'
            },
            default: {
                label: 'Default'
            }
        }
    },
    timeRegistration: {
        overview: {
            title: 'Entries',
            stat: {
                total_duration: 'Total Duration',
                total_monetary_value: 'Total Value (€)',
                duration_per_user: 'Duration per User',
                duration_per_project: 'Duration per Project',
                duration_per_subproject: 'Duration per Sub project',
                duration_per_budget: 'Duration per Budget',
                monetary_value_per_budget: 'Value per Budget (€)',
                duration_per_ticket: 'Duration per Ticket',
                duration_per_day: 'Duration per Day',
                unlinked_duration: 'Unlinked Duration',
                total_records: 'Entries',
                avg_entry_duration: 'Avg Entry Duration',
            },
            exportButton: 'Export',
        },
        create: {
            title: 'Add entry',
        },
        edit: {
            title: 'Edit entry',
        },
        myTime: {
            title: 'My Time',
            collapsed: '(Collapsed {{hours}} hours and {{minutes}} minutes of future time off)',
            collapse: 'Show future time off',
            today: 'Today ({{date}})',
            yesterday: 'Yesterday ({{date}})',
            addButton: 'Add entry',
            addHolidayButton: 'Add holiday',
            addHoliday: {
                title: 'Add Holiday',
            },
            isAltered: 'This time registration has been altered by administration.',
            isUnlinked: 'This entry is not linked to a sub project (or project) yet, so it does not count towards any budget or project. Link a sub project to complete it.',
            lastWeekDay: {
                monday: 'Last monday ({{date}})',
                tuesday: 'Last tuesday ({{date}})',
                wednesday: 'Last wednesday ({{date}})',
                thursday: 'Last thursday ({{date}})',
                friday: 'Last friday ({{date}})',
                saturday: 'Last saturday ({{date}})',
                sunday: 'Last sunday ({{date}})',
            },
            weekDay: {
                monday: 'Monday {{date}}',
                tuesday: 'Tuesday {{date}}',
                wednesday: 'Wednesday {{date}}',
                thursday: 'Thursday {{date}}',
                friday: 'Friday {{date}}',
                saturday: 'Saturday {{date}}',
                sunday: 'Sunday {{date}}',
            },
            changeDate: 'Change date',
        },
        field: {
            id: { label: 'ID' },
            projectsOrTickets: { label: 'Projects or tickets' },
            subprojectsOrTickets: { label: 'Sub projects or tickets' },
            subprojects: { label: 'Sub projects' },
            budgets: { label: 'Budgets' },
            projects: { label: 'Projects' },
            user: { label: 'User' },
            tickets: { label: 'Tickets' },
            description: { label: 'Description' },
            date: { label: 'Date' },
            startedAt: { label: 'Started' },
            endedAt: { label: 'Ended' },
            duration: { label: 'Duration' },
            projectTeam: { label: 'Project team' },
            userTeam: { label: 'User team' }
        },
    },
    company: {
        overview: {
            title: 'Companies',
            addButton: 'Add company'
        },
        create: {
            title: 'Add company'
        },
        edit: {
            title: 'Edit company'
        },
        viewport: {
            title: 'Customer',
            editCompany: 'Edit company',
            addContact: 'Add contact',
            header: {
                mainContact: 'Main contact',
                responsible: 'Responsible'
            },
            kpi: {
                activeContracts: 'Active contracts',
                hoursThisMonth: 'Hours this month',
                hoursTotal: 'Hours total'
            },
            section: {
                contracts: 'Contracts',
                projects: 'Projects',
                budgets: 'Budgets',
                subprojects: 'Sub projects',
                hours: 'Hours clocked',
                contacts: 'Contacts'
            },
            contract: {
                invoice: 'Invoicing',
                budgets: 'Budgets',
                leads: 'Leads'
            },
            budget: {
                add: 'Add budget',
                subprojects: 'Sub projects',
                usage: 'Usage',
                manageLink: 'Manage budgets and sub projects on the customer page →',
                legacyAllocation: 'This budget is linked to this project via a legacy percentage allocation',
                showFinished: 'Show finished'
            },
            subproject: {
                add: 'Add sub project',
                ownBudget: 'Own budget',
                project: 'Project',
                budget: 'Budget',
                showCompleted: 'Show completed',
                openPlanning: 'Open the planning for this sub project'
            },
            project: {
                addProject: 'Add project',
                addBudget: 'Budget',
                addSubproject: 'Sub project',
                delete: 'Delete project',
                deleteBlocked: 'This project has time registrations, merge it into another project instead',
                deleteFailed: 'Project could not be deleted',
                deleteModal: {
                    title: 'Delete project {name}',
                    explanation: 'Are you sure you want to delete {name}? This cannot be undone.',
                    confirm: 'Delete',
                },
                merge: {
                    button: 'Merge into another project',
                    failed: 'Projects could not be merged',
                },
                mergeModal: {
                    title: 'Merge {name} into another project',
                    explanation: 'Everything on {name} — time registrations, sub projects, planning and comments — moves to the chosen project. {name} disappears afterwards. This cannot be undone.',
                },
                type: {
                    support: 'Support',
                    fixed_fee: 'Fixed fee',
                    unpaid: 'No budget'
                },
                team: 'Team',
                budget: 'Budget'
            },
            hours: {
                thisMonth: 'This month',
                lastMonth: 'Last month',
                total: 'Total',
                budgetHours: 'Budget hours',
                perMonth: '/ month',
                noData: 'No hours clocked in the last 12 months.',
                chartHint: 'Hover a month for details.'
            },
            contact: {
                name: 'Name',
                roles: 'Roles',
                main: 'Main contact',
                responsible: 'Responsible',
                onContracts: 'Role on {{contracts}} contract(s)'
            },
            empty: {
                contracts: 'No contracts yet. Add the first contract via "Add contract".',
                projects: 'No projects for this customer yet.',
                budgets: 'No budgets yet. Add the first budget via "Add budget" or from a project.',
                finishedBudgets: 'All budgets are finished. Enable "Show finished" to see them.',
                subprojects: 'No sub projects yet. Add the first sub project via "Add sub project" or from a project.',
                completedSubprojects: 'All sub projects are completed. Enable "Show completed" to see them.',
                contacts: 'No contacts yet. Add the first contact via "Add contact".'
            },
            rightPane: {
                placeholder: 'Select an item in the overview to view and edit its details.',
                newContract: 'New contract',
                newBudget: 'New budget',
                newSubproject: 'New sub project',
                newProject: 'New project'
            },
            unsavedChanges: {
                withName: 'You have unsaved changes on {{label}} "{{name}}". Do you want to discard them?',
                withoutName: 'You have unsaved changes on this {{label}}. Do you want to discard them?',
                company: 'You have unsaved changes on this customer. Do you want to discard them?',
                label: {
                    contact: 'contact',
                    contract: 'contract',
                    budget: 'budget',
                    subproject: 'sub project',
                    project: 'project',
                },
            },
            error: {
                title: 'Could not load this customer',
                fetchFailed: 'Something went wrong while loading the customer data. Check your permissions and try again.',
                saveFailed: 'Could not save. Check the form and your permissions, then try again.'
            }
        },
        field: {
            name: {
                label: 'Name'
            },
            shortName: {
                label: 'Short Name'
            },
            mainContact: {
                label: 'Main contact'
            },
            responsible: {
                label: 'Responsible'
            },
            qaEmail: {
                label: 'QA e-mail'
            },
            communicationRhythm: {
                label: 'Communication rhythm'
            },
            invoiceAgreement: {
                label: 'Invoice agreement'
            },
            reportingAgreement: {
                label: 'Reporting agreement'
            },
            responsibleTeam: {
                label: 'Responsible team'
            },
            contracts: {
                label: 'Contracts'
            },
            budgets: {
                label: 'Budgets',
                thisMonth: 'this month',
                total: 'total',
            },
            addContract: {
                label: 'Add contract'
            }
        }
    },
    project: {
        create: {
            title: 'Add project'
        },
        edit: {
            title: 'Edit project'
        },
        overview: {
            addButton: 'Add project',
            title: 'Projects'
        },
        field: {
            id: {
                label: 'ID'
            },
            name: {
                label: 'Name'
            },
            company: {
                label: 'Company'
            },
            quotationLink: {
                label: 'Quotation'
            },
            hasActiveBudget: {
                label: 'Has active budget'
            },
            team: {
                label: 'Team'
            },
            projectLead: {
                label: 'Project Lead'
            },
            teamMember: {
                label: 'Team member'
            },
            hidden: {
                label: 'Hidden (from My Time)',
                options: {
                    all: 'All',
                    visible: 'Visible',
                    hidden: 'Hidden'
                }
            }
        }
    },
    planningMilestone: {
        create: {
            title: 'Add milestone'
        },
        edit: {
            title: 'Edit milestone'
        },
        field: {
            name: {
                label: 'Name'
            },
            type: {
                label: 'Type'
            },
            status: {
                label: 'Status'
            },
            project: {
                label: 'Project'
            },
            startDate: {
                label: 'Start date'
            },
            deadline: {
                label: 'Deadline'
            },
            description: {
                label: 'Description'
            },
            order: {
                label: 'Order'
            }
        }
    },
    planningTicket: {
        create: {
            title: 'Add ticket'
        },
        edit: {
            title: 'Edit ticket'
        },
        field: {
            title: {
                label: 'Title'
            },
            status: {
                label: 'Status'
            },
            assignee: {
                label: 'Assignee'
            },
            estimatedHours: {
                label: 'Estimated hours'
            },
            spentHours: {
                label: 'Spent hours'
            },
            scheduledStart: {
                label: 'Scheduled start'
            },
            scheduledEnd: {
                label: 'Scheduled end'
            },
            description: {
                label: 'Description'
            },
            order: {
                label: 'Order'
            }
        }
    },
    contact: {
        overview: {
            title: 'Contacts',
            addButton: 'Add contact'
        },
        create: {
            title: 'Add Contact'
        },
        edit: {
            title: 'Edit contact'
        },
        field: {
            id: {
                label: 'ID'
            },
            name: {
                label: 'Name'
            },
            company: {
                label: 'Company'
            },
            fullName: {
                label: 'Name'
            },
            firstName: {
                label: 'First name'
            },
            lastName: {
                label: 'Last name'
            }
        }
    },
    team: {
        overview: {
            addButton: 'Add team'
        },
        create: {
            title: 'Add team'
        },
        edit: {
            title: 'Edit team'
        },
        field: {
            id: {
                label: 'ID'
            },
            company: {
                label: 'Company'
            },
            name: {
                label: 'Name'
            }
        }
    },
    history: {
        modal: {
            milestone: {
                title: 'History milestone'
            }
        }
    },
    phabricator: {
        linked: 'Linked with Phabricator'
    },
    server: {
        overview: {
            addButton: 'Add server',
            title: 'Server overview'
        },
        create: {
            title: 'Create server'
        },
        edit: {
            title: 'Edit server'
        },
        field: {
            id: {
              label: 'ID'
            },
            serverUrl: {
                label: 'Server URL'
            },
            company: {
                label: 'Company'
            },
            name: {
                label: 'Name'
            },
            iaeVersion: {
                label: 'IAE version'
            },
            branch: {
                label: 'Branch'
            },
            softwareVersion: {
                label: 'Software version'
            },
            buildDate: {
                label: 'Build date',
            },
            lastRetrievedDate: {
                label: 'Last retrieved'
            },
            team: {
                label: 'Team'
            },
            commitId: {
                label: 'Commit Hash'
            },
            commitNumber: {
                label: 'Commit Number'
            },
            serverType: {
                label: 'Type',
                option: {
                    staging: 'Staging',
                    uat: 'UAT',
                    production: 'Production'
                }
            },
            backups: {
                label: 'Backups',
                disabled: 'Disabled',
                error: 'No backup found',
                enabled: {
                    label: 'Backups',
                    option: {
                        enabled: 'Enabled',
                        both: 'Both',
                        disabled: 'Disabled'
                    }
                },
                type: {
                    label: 'Backup type',
                },
                date: {
                    label: 'Last backup created',
                },
                size: {
                    label: 'Last backup size (min. in bytes)',
                },
            },
            error: {
                label: 'Error'
            }
        }
    },
    thread: {
        field: {
            notes: {
                none: 'No notes',
                more: '({{count}} more)',
            },
        },
    },
    note: {
        field: {
            contents: { label: 'Contents' },
        },
    },
    module: {
        create: {
          title: 'Add module'
        },
        edit: {
            title: 'Edit module'
        },
        field: {
            id: {
                label: 'Id',
            },
            name: {
                label: 'Name'
            },
            team: {
                label: 'Team'
            },
            callSign: {
                label: 'Call Sign'
            },
            description: {
                label: 'Description & Relevant Process'
            },
            origin: {
                label: 'Origin project'
            },
            logo: {
                label: 'Logo'
            }
        }
    },
    chapter: {
        overview: {
            addButton: 'Add'
        },
        edit: {
            title: 'Edit chapter'
        },
        create: {
            title: 'Add chapter'
        },
        field: {
            order: {
                label: 'Order'
            },
            name: {
                label: 'Name'
            }
        }
    },
    document: {
        edit: {
            title: 'Edit document'
        },
        field: {
            chapter: {
                label: 'Chapter'
            },
            order: {
                label: 'Order'
            },
            name: {
                label: 'Name'
            },
            responsible: {
                label: 'Reponsible person'
            },
            documentUrl: {
                label: 'Url'
            },
            lastRevisionDate: {
                label: 'Last revision date'
            },
            lastChangedDate: {
                label: 'Last changed date',
            },
            type: {
                label: 'Document type',
                option: {
                    document: 'Document',
                    register: 'Register',
                    form: 'Form',
                    process: 'Process'
                }
            }
        },
        create: {
            title: 'Add document'
        }
    },
    workingStatus: {
        working: 'Working on {{subject}} since {{startedAt}}',
        notWorking: 'Not working',
        unspecified: 'unspecified',
    },
    contract: {
        overview: {
            addButton: 'Add contract',
            title: 'Contracts'
        },
        create: {
            title: 'Add contract'
        },
        edit: {
            title: 'Edit contract',
            sections: {
                project: 'Project',
                info: 'Project info',
                responsibilities: 'Responsibilities',
                budgets: 'Budgets'
            },
            budgets: {
                terms: 'Terms',
                allocation: 'Project allocation',
                addAllocation: 'Allocate to project',
                addType: {
                    'fixed fee': 'Add fixed fee budget',
                    support: 'Add support budget',
                    recurring: 'Add recurring budget',
                },
                addSubproject: 'Add sub project',
            }
        },
        field: {
            entity: {
                label: 'Entity'
            },
            company: {
                label: 'Company'
            },
            title: {
                label: 'Title'
            },
            reference: {
                label: 'Reference'
            },
            quotation: {
                label: 'Quotation'
            },
            description: {
                label: 'Description'
            },
            quotationLink: {
                label: 'Link quotation'
            },
            signedPdf: {
                label: 'Signed PDF'
            },
            customerContact: {
                label: 'Customer representative'
            },
            team: {
                label: 'Team'
            },
            projectLead: {
                label: 'Project Lead'
            },
            devLead: {
                label: 'Dev lead'
            },
            uxdLead: {
                label: 'UXD Lead'
            },
            status: {
                label: 'Status'
            },
            budgetType: {
                label: 'Budget Type'
            },
            type: {
                label: 'Type'
            },
            startDate: {
                label: 'Start date'
            },
            endDate: {
                label: 'End date'
            },
            invoiceFrequency: {
                label: 'Invoice frequency'
            },
            paymentDays: {
                label: 'Payment days'
            }
        },
        status: {
            'quotation draft': 'Quotation draft',
            'quotation sent': 'Quotation sent',
            'quotation on hold': 'Quotation on hold',
            'quotation rejected': 'Quotation rejected',
            'contract active': 'Contract active',
            'contract finished': 'Contract finished'
        }
    },
    budget: {
        create: {
            title: 'Add budget'
        },
        edit: {
            title: 'Edit budget'
        },
        field: {
            name: {
                label: 'Name'
            },
            type: {
                label: 'Type'
            },
            description: {
                label: 'Description'
            },
            startDate: {
                label: 'Start date'
            },
            endDate: {
                label: 'End date'
            },
            budgetMoney: {
                label: 'Budget'
            },
            budgetHours: {
                label: 'Hour budget'
            },
            extraHoursArePaid: {
                label: 'Extra hours are paid'
            },
            budgetHourlyRate: {
                label: 'Hourly rate for extra hours'
            },
            budgetHourlyMaxHours: {
                label: 'Maximum amount of extra hours'
            },
            project: {
                label: 'Project'
            },
            contract: {
                label: 'Contract',
            },
            status: {
                label: 'Status'
            },
            hourlyRate: {
                label: 'Hourly rate'
            },
            minHours: {
                label: 'Minimum hours per month'
            },
            maxHours: {
                label: 'Maximum hours per month'
            },
        },
    },
    subproject: {
        create: {
            title: 'Add sub project'
        },
        edit: {
            title: 'Edit sub project'
        },
        field: {
            name: {
                label: 'Name'
            },
            budget: {
                label: 'Budget'
            },
            budgetHours: {
                label: 'Own hour budget'
            },
            description: {
                label: 'Description'
            },
            project: {
                label: 'Project'
            },
            type: {
                label: 'Type'
            },
            status: {
                label: 'Status',
                options: {
                    planning: 'Planning',
                    active: 'Active',
                    completed: 'Completed',
                    on_hold: 'On hold',
                }
            },
            startDate: {
                label: 'Start date'
            },
            deadline: {
                label: 'Deadline'
            },
        },
    },
            budgetProject: {
            field: {
                budget: {
                    label: 'Budget name'
                }
            }
        },
    startError: {
        label: 'Server error ({{errorCode}})',
        maintenance: 'Server maintenance. Please wait...',
        line1: 'Unknown error ocurred.',
        line2: 'Please contact support.',
    },
};
